<template>
  <div class="pageBackground">
    <dl>
      <dt>
        <img :src="imgsrc" />
      </dt>
      <dd>
        网络出问题了，我要
        <a href="javascript:void(0);" @click="refeshPage">立即刷新</a>
      </dd>
    </dl>
  </div>
</template>
<script>
import img from "@/assets/404.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "refreshPage",
  data() {
    return {
      imgsrc: img,
      clientType: "" //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
  },
  methods: {
    refeshPage() {
      if (this.clientType == "android") {
        window.android.getInfo(114, "");
      } else {
        window.webkit.messageHandlers.reloadPage.postMessage(null);
      }

      // window.android.getInfo(114, "");
    }
  }
};
</script>
<style lang="less">
.pageBackground {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  padding: 0 3%;
  dl {
    width: 100%;
    height: 300px;
    margin: 80px auto 0;
    dt {
      width: 100%;
      height: 245px;
      display: block;
      img {
        width: 100%;
        height: 100%;
      }
    }
    dd {
      display: block;
      font-size: 16px;
      margin-top: 10px;
      text-align: center;
      color: #333;
      a {
        display: inline-block;
        margin-left: 3px;
        color: #4bc08a;
      }
    }
  }
}
</style>